import gtag from './gtag';

export default function gtagSet(params) {
  gtag('set', params);
}
